import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import uiReducer from './reducers/uiReducer';
import paramsReducer from './reducers/paramsReducer';
import gamesReducer from './reducers/gamesReducer';
import filtersReducer from './reducers/filtersReducer';
import settingsReducer from './reducers/settingsReducer';
import groupsReducer from './reducers/groupsReducer';
import searchNamesReducer from './reducers/searchNamesReducer';

const store = configureStore({
  reducer: {
    gamesReducer,
    filtersReducer,
    uiReducer,
    paramsReducer,
    settingsReducer,
    groupsReducer,
    searchNamesReducer,
  },
});

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
